import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { withRouter, Link as RouterLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'

import { getContentRecord, fetchContentRecord, getContentIndex, fetchContentIndex } from 'alpha-js'
import { getBusinessInfo } from 'alpha-js'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListSubheader from '@material-ui/core/ListSubheader'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/IconButton'
import CancelIcon from '@material-ui/icons/Cancel'

import Markdown from '../ui/Markdown'

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 2,
    paddinTop: theme.spacing.unit * 4,
    minWidth: 300,
  },
  logo: {
    maxHeight: 32,
    [theme.breakpoints.up('sm')]: {
      maxHeight: 40
    }
  },
  subMenuContainer: {
    padding: theme.spacing.unit * 2,
    backgroundColor: '#eee'
  },
  linkText: {
  },
  cardImage: {
    width: '100%',
  },
  closeButton: {
    position: 'fixed',
    top: theme.spacing.unit,
    right: theme.spacing.unit,
    'z-index': 1350
  },  
});

const PageMenuItemCard = ({ classes, theme, body, images }) => {

  let imageUrl = null
  if (images && images !== undefined && images.length > 0) {
    imageUrl = images[0].image_url
    if (imageUrl.startsWith("/"))
      imageUrl = "http://178.128.86.10:8000" + imageUrl
  }

  return (
  <>
    { imageUrl &&
      <Box mb={1}>
        <img src={imageUrl} className={classes.cardImage} />
      </Box>
    }
    { body &&
      <Box>
        <Markdown source={ body } />
      </Box>
    }
  </>
  )
}

const PageMenu = ({ classes, theme, history, business, hasCatalog, headerPage, fetchHeaderPage, pageList, fetchPageList, hideMenu }) => {

  useEffect(() => {
    fetchHeaderPage()
    fetchPageList()
  }, [])
  
  let menuList = []
  if (headerPage.lastFetched && headerPage.data.sections !== undefined) {
    menuList = [
      {
        'link_title': 'Home',
        'link_to': '/'
      },
      ...headerPage.data.sections.filter((s) => s.component == 'HeaderMenu'),
    ]
  }
  else if (pageList.lastFetched) {
    let allPages = pageList.data.records.reduce((p, n) => {
      if (n.key == 'home' || n.component != 'Page')
        return p
      return [...p, {
        link_title: n.title,
        link_to: 'page/' + n.key
      }]
    }, [])
    
    menuList.push({
      'link_title': 'Home',
      'link_to': '/'
    })
/*    
    if (hasCatalog)
      menuList.push({
        'link_title': 'Belanja',
        'link_to': '/catalog'
      })
*/
    menuList.push({
      'link_title': 'Blog',
      'link_to': '/blog'
    })
    
    menuList.push(...allPages)    
  }
  
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(-1)  
  
  const openMenuItem = (item) => {
    setSelectedMenuIndex(-1)
    if (item.link_to) {
      if (item.link_to.startsWith("/"))
        history.push(item.link_to)
      else
        history.push("/" + item.link_to)
    }
  }  

  return (
    <div className={classes.root}>
      <Box className={ classes.closeButton }>
        <Button size='medium' className={ classes.closeButton} onClick={ hideMenu }>
          <CancelIcon/>
        </Button>
      </Box>
    
      <List>
        { menuList.map((item, index) => (
          <>
          <ListItem onClick={() => openMenuItem(item)}>
            <ListItemText
              primary={
              <Typography variant='h5' className={classes.linkText}>
              { item.link_title }
              </Typography>
              }
            />
          </ListItem>
            
          { item.items && item.items.length > 0 &&
            <Grid container className={classes.subMenuContainer}>
            { item.items.map((subItem) => (
              <Grid item xs={12}>
                <Box display='flex' flexDirection='column' onClick={()=>openMenuItem(subItem)}>
                  <PageMenuItemCard classes={classes} theme={theme} {...subItem}
                  /> 
                </Box>
              </Grid>
              )) 
            }
            </Grid>
          }
          </>
          ))
        }
      </List>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  return { 
    headerPage: getContentRecord(state, "page", "header"),
    pageList: getContentIndex(state, 'page', 'default'),
    business: getBusinessInfo(state, '0').data
    }
} 

const mapDispatchToProps = (dispatch, ownProps) => {
 
  return {
    fetchHeaderPage: () => {
      dispatch(fetchContentRecord('page', 'header'))
    },
    fetchPageList: (refresh=false) => {
      dispatch(fetchContentIndex('page', 'default', null, refresh))
    },
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(PageMenu)
  )
)